module.exports = __webpack_public_path__ + "img/db8e144.webp";